/**
 * クラス名：板金の手動バリ取対象サイズ画面
 * 作成者：チュー
 * 作成日：2023/06/21
 * バージョン：1.0
 */
import React, { useEffect, forwardRef, useState } from 'react';
import { Table } from 'react-bootstrap';
import { Row, Col, Input, Select, Checkbox } from 'antd';
import { handleKeyPress, isDigit, isDigitZenkaku, regexExp, toHalfWidth } from '../../../common/Common';
const Device_ManualBari = forwardRef((props, ref) => {
  const [editMode, setEditMode] = useState(false);
  const [roundHoleDia, setRoundHoleDia] = useState();
  const [rectangleDia, setRectangleDia] = useState();
  const [rectangleBariOnFlg, setRectangleBariOnFlg] = useState(false);

  useEffect(() => {
    setEditMode(props.editMode);
    setRoundHoleDia(props?.detailsData?.roundHoleDia);
    setRectangleDia(props?.detailsData?.rectangleDia);
    setRectangleBariOnFlg(props?.detailsData?.rectangleBariOnFlg);
  }, [props.editMode, props.detailsData]);

  const roundHoleDiaChange = (event, isCheckZenkaku = true) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    if (isCheckZenkaku && regexExp.test(event)) {
      // 全角の場合、
      event = toHalfWidth(event); // 半角へ変換
      if (!isDigit(event)) return;
    }
    setRoundHoleDia(event);
    props.updateRoundHoleDia(event);
  };

  const rectangleDiaChange = (event, isCheckZenkaku = true) => {
    if (regexExp.test(event) && !isDigitZenkaku(event)) return;
    if (isCheckZenkaku && regexExp.test(event)) {
      // 全角の場合、
      event = toHalfWidth(event); // 半角へ変換
      if (!isDigit(event)) return;
    }
    setRectangleDia(event);
    props.updateRectangleDia(event);
  };

  return (
    <>
      <Row style={{ marginLeft: 10 }} className="chargeAmount">
        <Col style={{ width: '40%' }}>
          <Table>
            <thead>
              <tr style={{ textAlign: 'center' }}>
                <td className="tbl-header" style={{ width: '20%' }}>
                  内径最小丸穴径(mm)
                </td>
                <td className="tbl-header" style={{ width: '20%' }}>
                  内径最小矩形周長(mm)
                </td>
                <td className="tbl-header" style={{ width: '10%' }}>
                  適応
                </td>
              </tr>
            </thead>
            <tbody>
              <tr style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                <td>
                  <Input
                    value={roundHoleDia}
                    onChange={(e) => roundHoleDiaChange(e.target.value, false)}
                    onBlur={(e) => roundHoleDiaChange(e.target.value)}
                    onPressEnter={(e) => roundHoleDiaChange(e.target.value)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                    style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                    className={editMode ? 'input-editable ' : 'input-non-editable'}
                  />
                </td>

                <td>
                  <Input
                    value={rectangleDia}
                    onChange={(e) => rectangleDiaChange(e.target.value, false)}
                    onBlur={(e) => rectangleDiaChange(e.target.value)}
                    onPressEnter={(e) => rectangleDiaChange(e.target.value)}
                    onKeyPress={(e) => {
                      handleKeyPress(e, false);
                    }}
                    style={{ padding: 3, width: '98.2%', height: 26, textAlign: 'center' }}
                    className={editMode ? 'input-editable ' : 'input-non-editable'}
                  />
                </td>

                <td>
                  <Checkbox
                    style={{ alignSelf: 'center' }}
                    checked={rectangleBariOnFlg}
                    onChange={(e) => {
                      setRectangleBariOnFlg(e.target.checked);
                      props.updateRectangleBariOnFlg(e.target.checked);
                    }}
                  ></Checkbox>
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>
    </>
  );
});

export default Device_ManualBari;
